import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { map, tap } from "rxjs/operators";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { PlaneraService } from "./services/planera.service";

@Injectable({
    providedIn: "root"
})
export class ArbetsorderBeteckningResolver  {
    private readonly router = inject(Router);
    private readonly planeraService = inject(PlaneraService);

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<number> {
        const beteckning = route.queryParamMap.get("beteckning");
        if(ObjectUtils.isNullOrUndefined(beteckning)) {
            return of(0);
        }
        return this.planeraService.getArbetsorderIdFromBeteckning(beteckning).pipe(
            map(res => res.id),
            tap(arbetsorderId => this.router.navigate([
                "/planera",
                arbetsorderId
            ]))
        );
    }
}
